var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlertToast',{attrs:{"should-display":_vm.shouldDisplay,"type":_vm.type,"title":_vm.title,"body":_vm.body,"icon":_vm.icon,"cta-text":_vm.ctaText},on:{"cta-click":_vm.handleClick,"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }